import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useTags } from "./hooks/use-tags";
import { TagCrudDataGrid } from "./tag-crud-data-grid";

export const TagsDialog: FC<{ open: boolean; handleClose: () => void }> = ({
  open,
  handleClose,
}) => {
  const { t } = useTranslation();
  const { data: tags, error, reload } = useTags();

  return (
    <Dialog open={open} onClose={handleClose} slotProps={{ paper: { sx: { width: "600px" } } }}>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LocalOfferOutlined />
          {t("Manage Content Library Tags")}
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{t("Failed to load tags, please try again")}</Alert>}
        <TagCrudDataGrid tags={tags} reload={reload} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} data-analytics-id="manage-tags-done" variant="outlined">
          {t("Done")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
